import { UUID } from "@/utils/wd_utils";
import { gptPubIds } from "@/service/wd_pubsub_config.js";
import { publish } from "@/service/wd_pubsub.js";

var PowerPoint = window.PowerPoint;

// 检查是否存在自定义属性，不存在则添加
// 暂时使用文件的url作为唯一标识，后续想其他办法，比如增加一个隐藏的shape等
export async function getOrAddCopilotId(onSuccess, onFailed) {
    PowerPoint = window.PowerPoint;
    // Office.context.document.settings.set("Office.AutoShowTaskpaneWithDocument", true);
    // Office.context.document.settings.saveAsync();
    let copilotId = "";
    try {
        await PowerPoint.run(async (context) => {
            let tags = context.presentation.tags
            tags.load("items")
            await context.sync()
            if (tags.items.length == 0) {
                copilotId = UUID()
                tags.add("COPILOTID", copilotId)
            }
            await context.sync()

            tags.items.forEach(tag => {
                tag.load("key", "value")
                context.sync()
                if (tag.key == "COPILOTID") {
                    copilotId = tag.value
                }
            });

            if (copilotId == "") {
                let tags = context.presentation.tags
                tags.load("items")
                await context.sync()

                copilotId = UUID()
                tags.add("COPILOTID", copilotId)
                await context.sync()
            }
        });

        // 成功获取或创建 copilotId
        if (copilotId && typeof onSuccess === "function") {
            onSuccess(copilotId);
        } else {
            // 调用失败回调
            if (typeof onFailed === "function") {
                onFailed("Error reading or creating copilot ID: ");
            }
        }
    } catch (error) {
        // 调用失败回调
        if (typeof onFailed === "function") {
            onFailed("Error reading or creating copilot ID: " + error.message);
        }
        
        copilotId = null; // 确保返回 null
    }

    return copilotId
}


// 检查是否存在自定义属性的agentUserId，不存在则添加
export async function getAgentUserId(onSuccess, onFailed) {
    PowerPoint = window.PowerPoint;
    let agentUserId = ""
    try {
        await PowerPoint.run(async (context) => {
            let tags = context.presentation.tags
            tags.load("items")
            await context.sync()

            for(let i = 0; i < tags.items.length; i++) {
                let tag = tags.items[i]
                tag.load("key", "value")
                context.sync()
                if (tag.key == "AGENTUSERID") {
                    agentUserId = tag.value
                }
            }
        });
        
        // 成功获取或创建 copilotId
        if (agentUserId && typeof onSuccess === "function") {
            onSuccess(agentUserId);
        } else {
            // 获取失败
            if (typeof onFailed === "function") {
                onFailed("Error reading or creating copilot ID: ");
            }
        }
    } catch (error) {
        // 调用失败回调
        if (typeof onFailed === "function") {
            onFailed("Error reading or creating copilot ID: " + error.message);
        }
        
        agentUserId = null; // 确保返回 null
    }
    
    return agentUserId
}

// 检查是否存在自定义属性的agentUserId，不存在则添加
export async function addAgentUserId(agentId) {
    PowerPoint = window.PowerPoint;
    try {
        await PowerPoint.run(async (context) => {
            let tags = context.presentation.tags
            tags.load("items")
            await context.sync()

            tags.add("AgentUserId", agentId)
            await context.sync()
        });
    } catch (error) {
        console.log("addAgentUserId");
        publish(gptPubIds.pubId_Local_PPT_init_error, error);
    }
}

// 添加一个Tag
// async function getCopilotId() {
//     let copilotId = "";
//     await PowerPoint.run(async (context) => {
//         let tags = context.presentation.tags
//         tags.load("items")
//         await context.sync()
//         if (tags.items.length == 0) {
//             copilotId = UUID()
//             tags.add("CopilotId", copilotId)
//         }
//         await context.sync()

//         tags.load("items")
//         await context.sync()

//         tags.items.forEach(async tag => {
//             tag.load("key", "value")
//             await context.sync()
//             if (tag.key == "CopilotId") {
//                 copilotId = tag.value
//             }
//         });
//         if (copilotId == "") {
//             let tags = context.presentation.tags
//             tags.load("items")
//             await context.sync()
//             if (tags.items.length == 0) {
//                 copilotId = UUID()
//                 tags.add("CopilotId", copilotId)
//             }
//             await context.sync()
//         }

//         return copilotId
//     });
// }

// 获取PPT当前所有的内容，并整理成JSON的结构
export async function getPPTContent(Success, Failed) {
    PowerPoint = window.PowerPoint
    let pptContent = [];
    try {
        await PowerPoint.run(async (context) => {
            let presentation = context.presentation;
            let slides = presentation.slides;
            slides.load("items");
            await context.sync();

            var slide = ""
            await slides.items.forEach(async (element, index) => {
                var selectedSlidesIDs = []
                var slide = context.presentation.slides.getItemAt(index)
                slide.load("id")
                await context.sync();
                selectedSlidesIDs.push(slide.id)
            });
            context.presentation.setSelectedSlides([slide.id]);


            let selectedSlides = context.presentation.getSelectedSlides();
            selectedSlides.load("items");
            await context.sync();
            let selectedSlide = selectedSlides.items[0];
            selectedSlide.load("shapes");
            await context.sync();
            let shapeCollection = selectedSlide.shapes;
            shapeCollection.load("items");
            await context.sync();
            let shapes = shapeCollection.items;

            for (let i = 0; i < shapes.length; i++) {
                // 一个Shape的JSON数据
                let shape = shapes[i];
                shape.load("$all");
                await context.sync();
                // var contentText
                // if (shape.type == "GeometricShape") {
                // shape text frame
                let textFrame = shape.textFrame;
                textFrame.load(
                    "hasText, topMargin, leftMargin, rightMargin, bottomMargin, verticalAlignment, wordWrap"
                );
                await context.sync();
                if (textFrame.hasText) {
                    // text range
                    textFrame.load("textRange");
                    await context.sync();
                    let textRange = textFrame.textRange;
                    textRange.load("$all");
                    await context.sync();
                    // contentText += textRange.text;
                    break;
                }
                // }
            }


            for (let i = 0; i < slides.items.length; i++) {
                let slide = slides.items[i];
                let textArray = [];
                let imageArray = [];

                let shapes = slide.shapes;
                shapes.load("items");
                await context.sync();

                for (let j = 0; j < shapes.items.length; j++) {
                    let shape = shapes.items[j];
                    if (shape.textFrame) {
                        // let textFrame = shape.textFrame;
                        shapes.load("items");
                        var textRange = shape.textFrame.textRange
                        textRange.load("text");
                        await context.sync()
                        if (textRange.text !== "") {
                            textArray.push(textRange.text);
                        }
                    }
                    if (shape.hasImage) {
                        let imageBlob = await shape.image.getBlob();
                        imageArray.push(URL.createObjectURL(imageBlob));
                    }
                }

                pptContent.push({
                    pageNumber: i + 1,
                    text: textArray,
                    images: imageArray
                });
            }

            if (pptContent.length > 0) {
                if (typeof Success === "function") {
                    Success(pptContent);
                }
            } else {
                if (typeof Failed === "function") {
                    Failed("No content found in the presentation.");
                }
            }

            return pptContent
        });
    } catch (error) {
        console.log("getPPTContent");
        publish(gptPubIds.pubId_Local_PPT_init_error, error);
    }
}